const ModalHeader = ({ title, onClose, onGoBack, showBack = true, disableButtons = false }) => (
    <div className="modal-header">
        <button type="button" className="close-btn" onClick={onClose} disabled={disableButtons}>
            <img src="/assets/images/diary-icons/times.svg" alt="Close button" />
        </button>

        <h4 className="modal-title">{title}</h4>

        {showBack && (
            <button type="button" className="back-btn" onClick={onGoBack} disabled={disableButtons}>
                <img src="/assets/images/diary-icons/arrow-left.svg" alt="Back button" />
            </button>
        )}
    </div>
);

export default ModalHeader;
